/**
 * URL base del API (fetch, imágenes /uploads).
 * Si la página se sirve por HTTPS y la env usa `http://`, el navegador bloquea las peticiones (contenido mixto).
 * En el cliente forzamos https salvo localhost / 127.0.0.1.
 */
export function getApiBaseUrl(): string {
  const raw = process.env.NEXT_PUBLIC_API_BASE_URL ?? "http://localhost:4000";
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    if (raw.startsWith("http://") && !/^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(raw)) {
      return raw.replace(/^http:\/\//, "https://");
    }
  }
  return raw;
}
